import { render, staticRenderFns } from "./LeftNav.vue?vue&type=template&id=780410d8&"
import script from "./LeftNav.vue?vue&type=script&lang=ts&"
export * from "./LeftNav.vue?vue&type=script&lang=ts&"
import style0 from "./LeftNav.vue?vue&type=style&index=0&id=780410d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports